// @flow
import axios from 'lib/defaultClient';

export type WriteCommentPayload = {
  eventId: string,
  text: string,
  replyTo?: ?string,
};

export const writeComment = ({ eventId, text, replyTo }: WriteCommentPayload) =>
  axios.post(`/events/${eventId}/comments`, {
    text,
    reply_to: replyTo,
  });

export type ReadCommentsPayload = {
  eventId: string,
};

export const readComments = ({ eventId }: ReadCommentsPayload) =>
  axios.get(`/events/${eventId}/comments`);

export type ReadSubCommentsPayload = {
  eventId: string,
  commentId: string,
  parentId?: ?string,
};

export const readSubComments = ({ eventId, commentId }: ReadSubCommentsPayload) =>
  axios.get(`/events/${eventId}/comments/${commentId}/replies`);

export type RemoveCommentPayload = {
  eventId: string,
  commentId: string,
};

export const removeComment = ({ eventId, commentId }: RemoveCommentPayload) => {
  return axios.delete(`/events/${eventId}/comments/${commentId}`);
};

export type EditCommentPayload = {
  eventId: string,
  commentId: string,
  text: string,
  parentId: ?string,
};

export const editComment = ({ eventId, commentId, text }: EditCommentPayload) =>
  axios.patch(`/events/${eventId}/comments/${commentId}`, { text });



// WEBPACK FOOTER //
// ./src/lib/api/events/comments.js